module.exports = __webpack_public_path__ + "img/icon-dispositivos.1ecad407.svg";